import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="claim-reexport-form"
export default class extends Controller {
  static targets = ["folder", "folderPreview"]

  connect() {
    this.updateFolderPreview()
  }

  updateFolderPreview() {
    if (!this.hasFolderTarget || !this.hasFolderPreviewTarget) return

    this.folderPreviewTarget.textContent = `from_goodbill/${this.folderTarget.value}/`
  }
}
